// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__346tQ","label":"LabeledBox_label__1mwfS"};